import SectionHead from './SectionHead';
import { compareRows } from '@/mocks/meihei';

const caseNames = ['案例甲 · 冲榜型', '案例乙 · 合集型', '案例丙 · 解构型'];

export default function CompareSection() {
  return (
    <section id="duibi" className="anchor-target bg-cream py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHead
          eyebrow="横向对比 · 多维表"
          title="三个同类案例，放进同一张表比一比"
          desc="起因、传播、舆论、沉淀四个维度横向对齐，高亮处是该行里相对最典型的样本——想快速定位，就看高亮格。"
        />

        <div className="mt-10 overflow-hidden rounded-xl border border-line bg-paper">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[760px] border-collapse text-left">
              <caption className="sr-only">同类话题案例横向对比表</caption>
              <thead>
                <tr className="border-b border-line bg-cream/60">
                  <th className="px-5 py-4 text-[13px] font-semibold text-clay">对比维度</th>
                  {caseNames.map((c, idx) => (
                    <th key={c} className={`px-5 py-4 text-[13px] font-semibold ${idx === 0 ? 'text-ember-600' : 'text-ink'}`}>
                      <span className="inline-flex items-center gap-1.5">
                        {idx === 0 && <i className="ri-flag-2-fill" aria-hidden="true"></i>}
                        {c}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {compareRows.map((row) => (
                  <tr key={row.axis} className="border-b border-line/70 last:border-0">
                    <th className="whitespace-nowrap px-5 py-4 text-[13px] font-bold text-ink">{row.axis}</th>
                    {[row.a, row.b, row.c].map((cell, ci) => {
                      const active = ci === row.winner;
                      return (
                        <td key={ci} className="px-5 py-4">
                          <span
                            className={
                              active
                                ? 'inline-flex items-center gap-1.5 rounded-md bg-ember-50 px-2.5 py-1 text-[13px] font-semibold text-ember-700'
                                : 'inline-flex items-center gap-1.5 text-[13px] text-ink/70'
                            }
                          >
                            {active && <i className="ri-checkbox-circle-fill text-ember-500" aria-hidden="true"></i>}
                            {cell}
                          </span>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start gap-4 rounded-xl border border-line bg-paper p-5 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-honey-100 text-honey-500">
              <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="display text-[15px] font-bold text-ink">想快速判断属于哪类？</h3>
              <p className="mt-1 text-[13px] leading-relaxed text-clay">
                起源靠单个争议词、靠多源联动、还是靠事件链累积？对上号的，就是它最能对应的同类样本。
              </p>
            </div>
          </div>
          <a
            href="#pandian"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-[13px] font-semibold text-cream transition-colors hover:bg-ember-600"
          >
            回看同类盘点
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}